import clsx from 'clsx'
// import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu, ThemeModeSwitcher} from '../../../partials'
// import {useLayout} from '../../core'
import {DropdownDisparches} from '../../../../app/components/DropdownDispatches'
import {IInputMutation, useDispatchesStore} from '../../../../app/store/dipatches'
import {useDisclosure} from '../../../../app/hooks/useDisclosure'
import {useState} from 'react'
import {ModalInfoDispatchPendig} from '../../../../app/components/ModalInfoDispatchPendig'
import cascoImg from '../../../../app/assets/img/casco.png'
import {Alert, Button, Offcanvas, Spinner} from 'react-bootstrap'
import {handleUpdateApp} from '../../../../app/helpers'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const dipatches = useDispatchesStore((s) => s.dipatches)
  // const {config} = useLayout()
  const {isOpen, onClose, onOpen} = useDisclosure()
  const {
    isOpen: isOpenUpdateApp,
    onClose: onCloseUpdateApp,
    onOpen: onOpenUpdateApp,
  } = useDisclosure()
  const [infoDispatch, setInfoDispatch] = useState<null | IInputMutation>(null)

  const [loading, setLoading] = useState(false)

  const onLoading = (b: boolean) => {
    setLoading(b)
  }

  const updateDispatchPendig = (disptach: IInputMutation) => {
    setInfoDispatch(disptach)
  }

  return (
    <>
      <div className='app-navbar flex-shrink-0'>
        {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
          <Search />
        </div> */}

        {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div> */}
        <div className={clsx('app-navbar-item', itemClass)}>
          <Button
            size='sm'
            className='px-2 text-center'
            variant='light'
            title='Actualizar app'
            onClick={onOpenUpdateApp}
          >
            <i className='bi bi-gear-fill fs-3 m-0 p-0' />
          </Button>
        </div>
        <div className={clsx('app-navbar-item', itemClass)} title='Despachos pendientes'>
          <div
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            className={btnClass}
            style={{position: 'relative'}}
          >
            {dipatches.length > 0 && (
              <span
                className='bg-success position-absolute translate-middle  start-50 animation-blink'
                style={{fontSize: '10px', color: 'white', padding: '4px 6px', borderRadius: '100%'}}
              >
                {dipatches.length}
              </span>
            )}
            <i className={btnIconClass + ' bi bi-truck'} />
          </div>
          <DropdownDisparches updateDispatchPendig={updateDispatchPendig} onOpen={onOpen} />
        </div>
        {/* <div className={clsx('app-navbar-item', itemClass)}>
          <div
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            className={btnClass}
          >
            <KTIcon iconName='element-plus' className={btnIconClass} />
          </div>
          <HeaderNotificationsMenu />
        </div> */}

        {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

        <div className={clsx('app-navbar-item', itemClass)}>
          <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
        </div>

        <div className={clsx('app-navbar-item', itemClass)}>
          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          >
            <img src={cascoImg} alt='' />
          </div>
          <HeaderUserMenu />
        </div>

        {/* {config.app?.header?.default?.menu?.display && (
          <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
            <div
              className='btn btn-icon btn-active-color-primary w-35px h-35px'
              id='kt_app_header_menu_toggle'
            >
              <KTIcon iconName='text-align-left' className={btnIconClass} />
            </div>
          </div>
        )} */}
      </div>
      {infoDispatch && (
        <ModalInfoDispatchPendig isOpen={isOpen} onClose={onClose} info={infoDispatch} />
      )}

      <Offcanvas show={isOpenUpdateApp} onHide={onCloseUpdateApp} placement='end'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Configuración</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Alert variant='danger'>
            <h4>Forzar actualización</h4>
            <p>Esta acción actualizará la aplicación a la versión más reciente</p>
            <Button onClick={() => handleUpdateApp(onLoading)} disabled={loading} variant='danger'>
              {loading && <Spinner animation='border' size='sm' className='me-2' />}
              Actualizar
            </Button>
          </Alert>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export {Navbar}
